import React, { useState } from "react";
import { Link } from "react-router-dom";
function PerformanceDashboard() {
  return (
    <>
      <div className="page-header">
        <h1>Performance Dashboard</h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li>
            <Link to="/employeelist">
              <span>/</span>Performance Dashboard{" "}
            </Link>
          </li>
          <li className="current">
            <span>/</span>Performance
          </li>
        </ul>
      </div>
      <div className="row_bg">
        <div className="dash_white_box2">
          <div className="row mb30">
            <div
              className="col-sm-7 col-md-7"
              style={{ marginLeft: "25%", textAlign: "center" }}
            >
              <img
                style={{ width: "70%" }}
                src="/assets/images/user_dashboard_img.png"
                alt="Dashboard"
              />
              <h1>Welcome to Performance Dashboard</h1>
              <p></p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default PerformanceDashboard;
